<!--<template>
    <ul class="nav nav-pills nav-fill mt-2 mb-5">
        <li class="nav-item">
            <Link :href="$route('booking.step1')" class="nav-link" :class="{ active: active(1) }" :attrs="attrs(1)" v-bind="attrs(1)" :data="linkData(1)" preserve-scroll>Reisedaten</Link>
        </li>
        <li class="nav-item">
            <Link v-if="travelDateSlug" :href="$route('booking.step2', { travelDate: travelDateSlug })" class="nav-link" :class="{ active: active(2), disabled: disbaled(2) }" :data="linkData(2)" v-bind="attrs(2)" preserve-scroll>Teilnehmer</Link>
        </li>
        <li class="nav-item">
            <Link v-if="travelDateSlug" :href="$route('booking.step3', { travelDate: travelDateSlug })" class="nav-link" :class="{ active: active(3), disabled: disbaled(3) }" :data="linkData(3)" v-bind="attrs(3)" preserve-scroll>Zahlung</Link>
        </li>
        <li class="nav-item">
            <Link v-if="travelDateSlug" :href="$route('booking.step4', { travelDate: travelDateSlug })" class="nav-link" :class="{ active: active(4), disabled: disbaled(4) }" :data="linkData(4)" v-bind="attrs(4)" preserve-scroll>Bestätigung</Link>
        </li>
    </ul>
</template>
-->

<template>
  <div class="booking-steps">
    <Link
      :href="
        $route('booking.step1', {
          travelDate: travelDateSlug,
          tid: travelId,
          tdid: travelDateId,
        })
      "
      class="booking-step"
      :class="{ edited: (active(2) || active(3) || active(4)), active: active(1) }"
      :attrs="attrs(1)"
      v-bind="attrs(1)"
      preserve-scroll
    >
      <div class="booking-step-name">
        <div class="booking-icon">
          <i class="fa-solid fa-person-skiing"></i>
        </div>
        <div class="booking-name">
          <span>Reisedaten</span>
        </div>
      </div>
    </Link>
    <Link
      v-if="travelDateSlug"
      :href="
        $route('booking.step2', {
          travelDate: travelDateSlug,
          tid: travelId,
          tdid: travelDateId,
        })
      "
      class="booking-step"
      :class="{ edited: (active(3) || active(4)), active: active(2), disabled: disbaled(2) }"
      v-bind="attrs(2)"
      preserve-scroll
    >
      <div class="booking-step-status">
        <span class="booking-step-status-item"></span>
      </div>
      <div class="booking-step-name">
        <div class="booking-icon">
          <i class="fa-solid fa-users"></i>
        </div>
        <div class="booking-name">
          <span>Teilnehmer</span>
        </div>
      </div>
    </Link>
    <Link
      v-if="travelDateSlug"
      :href="
        $route('booking.step3', {
          travelDate: travelDateSlug,
          tid: travelId,
          tdid: travelDateId,
        })
      "
      class="booking-step"
      :class="{ edited: active(4), active: active(3), disabled: disbaled(3) }"
      v-bind="attrs(3)"
      preserve-scroll
    >
      <div class="booking-step-status">
        <span class="booking-step-status-item"></span>
      </div>
      <div class="booking-step-name">
        <div class="booking-icon">
          <i class="fa-solid fa-money-bill-1"></i>
        </div>
        <div class="booking-name">
          <span>Zahlung</span>
        </div>
      </div>
    </Link>
    <Link
      v-if="travelDateSlug"
      class="booking-step"
      :class="{ active: active(4), disabled: disbaled(4) }"
      v-bind="attrs(4)"
      preserve-scroll
    >
      <div class="booking-step-status">
        <span class="booking-step-status-item"></span>
      </div>
      <div class="booking-step-name">
        <div class="booking-icon">
          <i class="fa-solid fa-thumbs-up"></i>
        </div>
        <div class="booking-name">
          <span>Bestätigung</span>
        </div>
      </div>
    </Link>
  </div>
</template>



<script setup>
import { computed } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";
import { Link } from "@inertiajs/inertia-vue3";
const bookingForm = computed(() => usePage().props.value.bookingForm);

const travelId = computed(() => _.get(bookingForm.value, "travel.id"));
const travelDateId = computed(() => _.get(bookingForm.value, "travel_date.id"));
const travelDateSlug = computed(() =>
  _.get(bookingForm.value, "travel_date.slug")
);

function active(no) {
  return bookingForm.value.step_current.no == no;
}

function disbaled(no) {
  return bookingForm.value.step_current.no < no;
}

function attrs(no) {
  let attrs;
  if (active(no)) {
    attrs = { "aria-current": "page" };
  }
  return attrs;
}

function linkData(no) {
  let data = { t: sessionStorage.getItem("tab_id") };
  if (no == 1) {
    if (travelId.value) {
      data.tid = travelId.value;
    }
    if (travelDateId.value) {
      data.tdid = travelDateId.value;
    }
  }
  // console.log(data);
  return data;
}
</script>
